import { render, staticRenderFns } from "./image-item.vue?vue&type=template&id=2d4c2959&scoped=true&"
import script from "./image-item.vue?vue&type=script&lang=js&"
export * from "./image-item.vue?vue&type=script&lang=js&"
import style0 from "./image-item.vue?vue&type=style&index=0&id=2d4c2959&prod&lang=scss&scoped=true&"
import style1 from "./image-item.vue?vue&type=style&index=1&id=2d4c2959&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4c2959",
  null
  
)

export default component.exports